export const buildProvenance = { "commitHash": "f61c326030984e61596f3ea16d805bdbd8c22203", "branchName": "refs/heads/main", "buildDate": "2025-05-09T16:07:06.758Z", "version": "2025.2.9747" };
